import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, Checkbox } from 'semantic-ui-react'
import SvgSpinner from '../SvgSpinner/SvgSpinner'

class ModalWindow extends Component {
    static propTypes = {
        availableFilters: PropTypes.array.isRequired,
        selectedFilters: PropTypes.array.isRequired,
        confirmText: PropTypes.string.isRequired,
        loading: PropTypes.bool,
        cancelText: PropTypes.string,
        modal: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onReset: PropTypes.func.isRequired,
        onToggleFilter: PropTypes.func.isRequired,
    }

    static defaultProps = {
        cancelText: 'Сбросить все',
        confirmText: 'Сохранить',
    }

    isFilterSelected = (filterValue) => {
        const { selectedFilters } = this.props
        return selectedFilters.includes(filterValue)
    }

    renderFilter = (filter, i) => (
        <div key={`${filter.value}_${i}`} className="filters-list-item">
            <Checkbox
                label={filter.label}
                checked={this.isFilterSelected(filter.value)}
                onChange={() => this.props.onToggleFilter(filter.value)}
            />
        </div>
    )

    render() {
        const { availableFilters, confirmText, cancelText, modal, onSubmit, onCancel, onReset } = this.props

        return (
            <Modal
                className="filters-modal"
                open={modal.isOpen}
            >
                <button type="button" className="modal-close" onClick={() => onCancel()}>
                    <i aria-hidden="true" className="icon">
                        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"/>
                        </svg>
                    </i>
                </button>
                <h2>Фильтры</h2>
                <div className="filters-modal__content">
                    <div className="filters-modal__title">Отображаемые языки</div>
                    <div className="filters-modal__list">
                        {availableFilters.map(this.renderFilter)}
                    </div>
                </div>
                <Modal.Actions>
                    <button type="button" className="btn-cancel" onClick={() => onReset()}>{cancelText}</button>
                    <button
                        type="button"
                        className="btn btn-green btn-spinner"
                        disabled={!!this.props.loading}
                        onClick={() => onSubmit()}
                    >
                        {this.props.loading ? (<SvgSpinner/>) : confirmText}
                    </button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default ModalWindow
